import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3217bbee&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3217bbee')) {
      api.createRecord('3217bbee', component.options)
    } else {
      api.reload('3217bbee', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=3217bbee&", function () {
      api.rerender('3217bbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/App.vue"
export default component.exports